if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.existingProductIds = [];
    }

    async connectedCallback() {
      const baseUrl = this.dataset.baseUrl;
      const productIds = this.dataset.productId.split(",");

      this.existingProductIds = this.existingProductIds.concat(productIds);

      const response  = await Promise.all(productIds.map((productId) => {
        return fetch(`${baseUrl}?section_id=product-recommendations&product_id=${productId}&limit=10`)
          .then((res) => res.text());
      }));

      if (!response.length) return;

      response.forEach((productHtml, index) => {
        if (productHtml.trim() === "") return;

        if (index === 0) {
          const createElement = document.createElement('div');
          createElement.innerHTML = productHtml;

          const insideContent = createElement.querySelector('.recommendation-content');

          if (!insideContent) return;

          this.innerHTML = insideContent.outerHTML;

          const itemsWrapper = this.querySelector('.recommendation-slider');
          const productItems = this.querySelectorAll(".grid-view-item.product-card");

          itemsWrapper.innerHTML = '';

          productItems.forEach((productItem) => {
            const productId = productItem.dataset.productId;

            if (!this.existingProductIds.includes(productId)) {
              itemsWrapper.appendChild(productItem);
              this.existingProductIds.push(productId);
            }
          });
        }

        if (index > 0) {
          const itemsWrapper = this.querySelector('.recommendation-slider');

          if (!itemsWrapper) return;
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = productHtml;

          const productItems = tempDiv.querySelectorAll(".grid-view-item.product-card");

          productItems.forEach((productItem) => {
            const productId = productItem.dataset.productId;

            if (!this.existingProductIds.includes(productId)) {
              this.existingProductIds.push(productId);
              itemsWrapper.appendChild(productItem);
            }
          })
        }
      }) 

      this.initSlider();
    }

    initSlider() {
      if ($(".recommendation-slider").length) {
        $(".recommendation-slider").slick({
          arrows: true,
          dots: true,
          infinite: false,
          speed: 300,
          slidesToShow: 3,
          slidesToScroll: 3,
          centerMode: false,
          adaptiveHeight: true,
          variableWidth: true,
          responsive: [
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                variableWidth: true
              },
            },
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true
              },
            },
          ],
        });
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}

